import {connect} from 'react-redux';
import React from 'react';
import Slider from 'react-slick';

import Blocklink from '../elements/Blocklink';
import Image from '../elements/SafeImage';
import Screen from './Screen';
import Scrollable from '../elements/Scrollable';
import TopBar from '../elements/TopBar/TopBar';
import config from '../../configs/config';

class GetMostScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {page: 0};
    }
    render() {
        var {i18n} = this.props;
        var imageStyle = {
            display: 'block',
            width: '100%',
        };
        var description;
        console.log(this.state);
        switch (this.state.page) {
            case 0:
                description = i18n['label.description.explain.getstarted'];
                break;
            case 1:
                description = i18n['label.description.explain.networkapp'];
                break;
            case 2:
                description = i18n['label.description.explain.Allabout.the.event'];
                break;
            case 3:
                description = i18n['label.description.explain.Well programmed'];
                break;
            case 4:
                description = i18n['label.description.explain.lookingforknowledge'];
                break;
            case 5:
                description = i18n['label.description.explain.Let.smeet!'];
                break;
            case 6:
                description = i18n['label.description.explain.meet.up'];
                break;
            case 7:
                description = i18n['label.description.explain.Stay.in.touch'];
                break;
        }

        const header = (
            <>
                <TopBar returnURL="/"></TopBar>
            </>
        );

        return (
            <Screen header={header}>
                <Scrollable>
                    <Slider dots={true} slidesToShow={1} touchMove={true} infinite={false} cssEase="ease-out" afterChange={this.handleAfterChange.bind(this)}>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_1.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_1.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_2.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_2.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_3.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_3.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_4.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_4.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_5.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_5.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_6.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_6.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_7.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_7.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                        <div>
                            <Image
                                src={['img/get_most/', this.props.locale, '_scherm_pagina_8.png'].join('')}
                                altSrc={['img/get_most/en_scherm_pagina_8.png'].join('')}
                                style={imageStyle}
                            />
                        </div>
                    </Slider>
                    <div
                        className="content"
                        style={{
                            marginTop: 30,
                        }}>
                        <p>{description}</p>
                    </div>
                    <div
                        className="footer"
                        style={{
                            padding: '10px 0',
                        }}>
                        <Blocklink className="margins" next href={'mailto:' + config.supportAddress}>
                            {i18n['label.contact.support']}
                        </Blocklink>
                        <Blocklink className="margins" next href="/user_agreement">
                            {i18n['label.user.agreement']}
                        </Blocklink>
                        <Blocklink className="margins" next href="/privacy_statement">
                            {i18n['label.PrivacyPolicy.title']}
                        </Blocklink>
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    handleAfterChange(page) {
        this.setState({page});
    }
}

export default connect(function(state, props) {
    return Object.assign({}, props, {
        i18n: state.i18n.translations,
        locale: state.i18n.locale,
    });
})(GetMostScreen);
